<div class="modele-ordo-panel" [class.modele-ordo-panel--collapsed]="collapsed">

  <div class="modele-ordo-panel__toggle">
    <div class="modele-ordo-panel__toggle-handle" (click)="togglePanel()">
      <div class="modele-ordo-panel__toggle-chevron">
        {{ collapsed ? '◀' : '▶' }}
      </div>
      <div class="modele-ordo-panel__toggle-label">MODÈLES</div>
    </div>
  </div>

  <div class="modele-ordo-panel__content" *ngIf="!collapsed">

    <div class="modele-ordo-panel__header">
      <div class="modele-ordo-panel__title">Modèles d'ordonnance</div>
      <button
        type="button"
        class="modele-ordo-panel__close-btn"
        title="Fermer"
        (click)="togglePanel()">
        ✕
      </button>
    </div>

    <div class="modele-ordo-panel__tabs">
      <button
        type="button"
        class="modele-ordo-panel__tab"
        [class.modele-ordo-panel__tab--active]="currentTab === 'perso'"
        (click)="selectTab('perso')">
        Mes modèles
      </button>

      <button
        type="button"
        class="modele-ordo-panel__tab"
        [class.modele-ordo-panel__tab--active]="currentTab === 'cabinet'"
        (click)="selectTab('cabinet')">
        Cabinet
      </button>
    </div>

    <div class="modele-ordo-panel__body">

      <div class="modele-ordo-loader" *ngIf="isLoading">
        Chargement des modèles...
      </div>

      <ng-container *ngIf="!isLoading">

        <!-- MODELES PERSONNELS -->
        <ng-container *ngIf="currentTab === 'perso'">

          <div class="modele-ordo-search">
            <input
              type="text"
              class="modele-ordo-search__input"
              placeholder="Rechercher un modèle..."
              autocomplete="off"
              [value]="searchPersoInput"
              (input)="onSearchPersoInput($event)"
              (keyup.enter)="searchModelesPerso()">

            <button
              type="button"
              class="modele-ordo-search__clear"
              title="Effacer"
              *ngIf="searchPersoInput"
              (click)="clearSearchPerso()">
              <mat-icon>close</mat-icon>
            </button>

            <button
              type="button"
              class="modele-ordo-search__button"
              title="Rechercher"
              [disabled]="isLoading"
              (click)="searchModelesPerso()">
              <mat-icon>search</mat-icon>
            </button>
          </div>

          <div
            class="modele-ordo-empty"
            *ngIf="modelesPerso.length === 0">
            Aucun modèle enregistré
          </div>

          <div
            class="modele-ordo-item"
            *ngFor="let modele of modelesPerso"
            title="Double-cliquez pour utiliser ce modèle"
            (dblclick)="selectModele(modele.id)">

            <div class="modele-ordo-item__name">
              {{ modele.nom }}
            </div>

            <div
              class="modele-ordo-item__actions"
              (click)="$event.stopPropagation()"
              (dblclick)="$event.stopPropagation()">

              <button
                type="button"
                class="modele-ordo-item__action modele-ordo-item__action--use"
                title="Utiliser ce modèle"
                (click)="selectModele(modele.id)">
                <mat-icon>add</mat-icon>
              </button>

              <button
                type="button"
                class="modele-ordo-item__action modele-ordo-item__action--delete"
                title="Supprimer ce modèle"
                (click)="deleteModele(modele.id, modele.nom, $event)">
                <mat-icon>delete_outline</mat-icon>
              </button>

            </div>

          </div>
          <button type="button" class="modele-ordo-load-more"
            *ngIf="hasMorePerso" disabled]="isLoadingMorePerso" (click)="loadMorePerso()">
            {{ isLoadingMorePerso ? 'Chargement...' : 'Afficher plus...' }}
          </button>
        </ng-container>

        <!-- MODELES CABINET -->
        <ng-container *ngIf="currentTab === 'cabinet'">

          <div
            class="modele-ordo-empty"
            *ngIf="profilsCabinet.length === 0">
            Aucun modèle disponible dans le cabinet
          </div>

          <div
            class="modele-ordo-profil"
            *ngFor="let profil of profilsCabinet">

            <div class="modele-ordo-profil__header">

              <button
                type="button"
                class="modele-ordo-profil__main"
                (click)="toggleProfil(profil.idProfil)">

                <span class="modele-ordo-profil__chevron">
                  {{ profilsExpanded.has(profil.idProfil) ? '▾' : '▸' }}
                </span>

                <span class="modele-ordo-profil__name">
                  {{ getProfilLabel(profil.idProfil) }}
                </span>

                <span class="modele-ordo-profil__count">
                  {{ profil.total }}
                </span>

              </button>

              <button
                type="button"
                class="modele-ordo-profil__refresh"
                title="Actualiser les modèles de ce praticien"
                (click)="refreshProfilCabinet(profil.idProfil, $event)">
                <mat-icon>refresh</mat-icon>
              </button>

            </div>

            <div class="modele-ordo-profil__content" *ngIf="profilsExpanded.has(profil.idProfil)">

              <div class="modele-ordo-loader" *ngIf="profilsLoading.has(profil.idProfil)">
                Chargement...
              </div>
              <div class="modele-ordo-empty modele-ordo-empty--small" *ngIf="!profilsLoading.has(profil.idProfil) && getModelesCabinet(profil.idProfil).length === 0">
                Aucun modèle
              </div>

              <div class="modele-ordo-item modele-ordo-item--cabinet" *ngFor="let modele of getModelesCabinet(profil.idProfil)"
                title="Double-cliquez pour utiliser ce modèle" (dblclick)="selectModele(modele.id)">

                <div class="modele-ordo-item__name">
                  {{ modele.nom }}
                </div>
                <div class="modele-ordo-item__actions" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
                  <button type="button" class="modele-ordo-item__action modele-ordo-item__action--use"
                    title="Utiliser ce modèle" (click)="selectModele(modele.id)">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>

              </div>
              <button
                type="button"
                class="modele-ordo-load-more"
                *ngIf="hasMoreCabinet(profil.idProfil)"
                [disabled]="profilsLoadingMore.has(profil.idProfil)"
                (click)="loadMoreCabinet(profil.idProfil, $event)">
                {{ profilsLoadingMore.has(profil.idProfil) ? 'Chargement...' : 'Afficher plus...' }}
              </button>

            </div>

          </div>

        </ng-container>

      </ng-container>

    </div>

  </div>

</div>
